import Constants from 'expo-constants'
import { createClient } from 'contentful'

const contentfulConfig = Constants.expoConfig?.extra?.contentful
const space = contentfulConfig?.spaceId
const accessToken = contentfulConfig?.accessToken
const environment = contentfulConfig?.environment ?? 'master'

if (!space || !accessToken) {
  console.error('Contentful configuration missing. Please check env.config.js')
}

export const contentfulClient = createClient({
  space: space ?? 'missing-contentful-space',
  accessToken: accessToken ?? 'missing-contentful-access-token',
  environment,
}).withoutUnresolvableLinks
